import { MutationTree } from "vuex";
import { SpinState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<SpinState> = {
  // Use in gl-common
  setMaskMain(state: SpinState, value: boolean) {
    state.maskMain = value;
  },
  [defineVuexName(MODULES.SPIN.COMMITS.SET_MASK_MAIN)](state: SpinState, value: boolean) {
    state.maskMain = value;
  },
  //setSplash
  [defineVuexName(MODULES.SPIN.COMMITS.SET_SPLASH)](state: SpinState, value: boolean): void {
    state.splash = value;
  },
  //setMaskGrandAccess
  [defineVuexName(MODULES.SPIN.COMMITS.SET_MASK_GRAND_ACCESS)](state: SpinState, value: boolean): void {
    state.maskGrandAccess = value;
  },
};

export default mutations;
